<template>
  <!-- 알림 상태 도움말 — "인증서 상태"로 오독되지 않도록 위챗 알림 발송 단계임을 명시하고
       전이 흐름을 번역 라벨로 보여준다(코드값은 보조 표기). china-inapi IssueStatus 6단계 기준. -->
  <a-popover trigger="click" placement="bottomLeft" :overlay-style="{ maxWidth: '520px' }">
    <template #title>
      <span class="ish-title">{{ $t('certstatus_help_title') }}</span>
    </template>
    <template #content>
      <div class="ish-body">
        <p class="ish-intro">{{ $t('certstatus_help_intro') }}</p>

        <div class="ish-section-label">{{ $t('certstatus_help_flow_label') }}</div>
        <div class="ish-flow">
          <template v-for="(s, i) in flow" :key="s.code">
            <span class="ish-chip ish-chip-mid">
              <span class="ish-chip-label">{{ $t(s.key) }}</span>
              <span class="ish-chip-code">{{ s.code }}</span>
            </span>
            <span v-if="i < flow.length - 1" class="ish-arrow" aria-hidden="true">→</span>
          </template>
          <span class="ish-arrow" aria-hidden="true">→</span>
          <span class="ish-branch">
            <span v-for="t in terminal" :key="t.code" :class="['ish-chip', t.cls]">
              <span class="ish-chip-label">{{ $t(t.key) }}</span>
              <span class="ish-chip-code">{{ t.code }}</span>
            </span>
          </span>
        </div>

        <div class="ish-section-label">{{ $t('certstatus_help_terminal_label') }}</div>
        <ul class="ish-list">
          <li><b>{{ $t('certificatelist_issue_status_notified') }}</b> — {{ $t('certstatus_help_desc_notified') }}</li>
          <li><b>{{ $t('certificatelist_issue_status_notify_failed') }}</b> — {{ $t('certstatus_help_desc_notify_failed') }}</li>
          <li><b>{{ $t('certificatelist_issue_status_suppressed') }}</b> — {{ $t('certstatus_help_desc_suppressed') }}</li>
        </ul>

        <p class="ish-note">{{ $t('certstatus_help_recover_note') }}</p>
      </div>
    </template>
    <QuestionCircleOutlined class="ish-icon" :title="$t('certstatus_help_title')" />
  </a-popover>
</template>

<script>
import { QuestionCircleOutlined } from '@ant-design/icons-vue';

export default {
  name: 'IssueStatusHelp',
  components: { QuestionCircleOutlined },
  data() {
    return {
      // 진행 순서(비종결) — china-inapi issue-status.enum.ts PENDING → SAVED → COUNTED
      flow: [
        { code: 'PENDING', key: 'certificatelist_issue_status_pending' },
        { code: 'SAVED', key: 'certificatelist_issue_status_saved' },
        { code: 'COUNTED', key: 'certificatelist_issue_status_counted' },
      ],
      // 종결 3종 — NOTIFY_FAILED 만 정책상 재시도로 다시 움직인다
      terminal: [
        { code: 'NOTIFIED', key: 'certificatelist_issue_status_notified', cls: 'ish-chip-ok' },
        { code: 'NOTIFY_FAILED', key: 'certificatelist_issue_status_notify_failed', cls: 'ish-chip-fail' },
        { code: 'SUPPRESSED', key: 'certificatelist_issue_status_suppressed', cls: 'ish-chip-sup' },
      ],
    };
  },
};
</script>

<style scoped>
.ish-icon { color: rgba(0, 0, 0, 0.45); cursor: help; margin-left: 4px; }
.ish-title { font-weight: 600; }
.ish-body { font-size: 13px; line-height: 1.6; }
.ish-intro { margin: 0 0 10px; }
.ish-section-label { font-size: 11px; letter-spacing: 0.06em; color: #8c8c8c; margin: 8px 0 4px; }
.ish-flow { display: flex; flex-wrap: wrap; align-items: center; gap: 6px; }
.ish-branch { display: flex; flex-direction: column; gap: 4px; }
.ish-arrow { color: #bfbfbf; }
.ish-chip { display: inline-flex; flex-direction: column; align-items: center; padding: 3px 10px; border-radius: 6px; line-height: 1.2; white-space: nowrap; }
.ish-chip-label { font-weight: 500; }
.ish-chip-code { font-family: "SF Mono", Menlo, monospace; font-size: 10px; opacity: 0.65; margin-top: 2px; }
.ish-chip-mid { background: #f0f2f7; color: #4a5a7a; }
.ish-chip-ok { background: #e7f3ea; color: #2f7d4f; }
.ish-chip-fail { background: #fbe9e5; color: #b8402f; }
.ish-chip-sup { background: #fbf1e3; color: #b26a12; }
.ish-list { margin: 0; padding-left: 16px; }
.ish-list li { margin: 2px 0; }
.ish-note { margin: 10px 0 0; padding-top: 8px; border-top: 1px dashed #e5e5e5; color: #595959; }
</style>
